/* eslint-disable */
export default function(_this) {
  return {
    create(widget, callback, ref) {
      if (!ref) ref = _this.getRef()

      widget.layout = 'b-card'

      let key = ref.child('widgets').push(widget, () => {
        if (callback) callback(key)
      }).key
    },
    read(callback, once) {
      _this.getRef('widgets')[once ? 'once' : 'on']('value', snapshot => {
        callback(snapshot.val() || {})
      })
    },
    readOne(widgetKey) {
      return new Promise(resolve => {
        _this
          .getRef('widgets')
          .child(widgetKey)
          .once('value', snapshot => {
            resolve(snapshot.val())
          })
      })
    },
    readData(callback, once) {
      _this.getRef('widgetsData')[once ? 'once' : 'on']('value', snapshot => {
        callback(snapshot.val() || {})
      })
    },
    updateData(newData, callback) {
      _this.getRef('widgetsData').set(newData, err => {
        if (err) callback(err)
        else callback(null)
      })
    },
    readDataByPath(path, callback) {
      let ref = _this.getRef('widgetsData')
      if (path) ref = _this.getRef('widgetsData').child(path)
      ref.once('value', snapshot => {
        callback(snapshot.val())
      })
    },
    updateDataByPath(path, newData, callback) {
      let ref = _this.getRef('widgetsData')
      if (path) ref = _this.getRef('widgetsData').child(path)
      ref.set(newData, err => {
        if (err) callback(err)
        else callback(null)
      })
    },
    readComputed(callback) {
      _this.getRef('widgetsComputed').on('value', snapshot => {
        let data = snapshot.val() || {}
        callback(data)
      })
    },
    update(key, updatedWidget, cb) {
      _this
        .getRef('widgets')
        .child(key)
        .update(updatedWidget, err => {
          if (!cb) return

          if (err) cb(err)
          else cb(null)
        })
    },
    delete(key, dependency, callback) {
      let promise = new Promise(resolve => {
        _this
          .getRef('widgets')
          .child(key)
          .remove(() => {
            if (dependency) resolve()
            if (callback) callback()
          })
      })

      promise.then(() => {
        _this
          .getRef('widgetsData')
          .child(dependency)
          .remove()
      })
    },
    getUserModels(uid, callback) {
      _this
        .getRef('userWidgetsData')
        .child(uid)
        .on('value', snapshot => {
          callback(snapshot.val())
        })
    },
    setUserModel(uid, modelKey, modelVal, callback) {
      modelKey = modelKey.replace(/\./g, '/')

      _this
        .getRef('userWidgetsData')
        .child(uid + '/' + modelKey)
        .set(modelVal, err => {
          if (callback) callback(err)
        })
    },
    createDataWidget(data, callback) {
      let widget = {
        title: data.title,
        dataPath: data.path,
        dataWidget: true,
        gsOptions: {
          x: 0,
          y: 0,
          w: data.w,
          h: data.h,
        },
        tab: data.tab,
      }

      _this.getRef('widgets').push(widget, () => {
        callback()
      })
    },
    async changeParentTab(tab, newParent) {
      const widgets = await new Promise(resolve => {
        _this
          .getRef('widgets')
          .orderByChild('tab')
          .equalTo(tab)
          .once('value', snapshot => {
            resolve(snapshot.val())
          })
      })

      if (!widgets) return

      for (let key in widgets) {
        widgets[key].tab = newParent
      }

      _this.getRef('widgets').update(widgets)
    },
    changeTab(widgetKey, tab, subtab, cb) {
      _this
        .getRef('widgets')
        .child(widgetKey)
        .update({ tab, subtab: subtab || null }, () => {
          cb()
        })
    },
  }
}
